import { UrlSegment } from "@angular/router";

export function articleUrlMatcher(url: UrlSegment[]) {
    const path = url.join('/');
    
    // Pattern pour URLs valides: /articles/[slug]/[id]
    const validPattern = /^(articles)\/([^\/]+)\/([^\/]+)$/;
    
    // Pattern pour URLs malformées: /articles/[slug][id]
    const malformedPattern = /^(articles)\/(.+?)([^\/]+)$/;
  
    const validMatch = path.match(validPattern);
    if (validMatch) {
      const [_, type, nom, id] = validMatch;
      return {
        consumed: url,
        posParams: {
          type: new UrlSegment(type, {}),
          nom: new UrlSegment(nom, {}),
          id: new UrlSegment(id, {})
        }
      };
    }
  
    const malformedMatch = path.match(malformedPattern);
    if (malformedMatch) {
      const [_, type, malformedSlug, id] = malformedMatch;
      return {
        consumed: url,
        posParams: {
          type: new UrlSegment(type, {}),
          malformedSlug: new UrlSegment(malformedSlug, {}),
          id: new UrlSegment(id, {})
        }
      };
    }
  
    return null;
  }
  export function newsUrlMatcher(url: UrlSegment[]) {
    const path = url.join('/');
    
    // Pattern pour URLs valides: /articles/[slug]/[id]
    const validPattern = /^(news)\/([^\/]+)\/([^\/]+)$/;
    
    // Pattern pour URLs malformées: /articles/[slug][id]
    const malformedPattern = /^(news)\/(.+?)([^\/]+)$/;
  
    const validMatch = path.match(validPattern);
    if (validMatch) {
      const [_, type, nom, id] = validMatch;
      return {
        consumed: url,
        posParams: {
          type: new UrlSegment(type, {}),
          nom: new UrlSegment(nom, {}),
          id: new UrlSegment(id, {})
        }
      };
    }
  
    const malformedMatch = path.match(malformedPattern);
    if (malformedMatch) {
      const [_, type, malformedSlug, id] = malformedMatch;
      return {
        consumed: url,
        posParams: {
          type: new UrlSegment(type, {}),
          malformedSlug: new UrlSegment(malformedSlug, {}),
          id: new UrlSegment(id, {})
        }
      };
    }
  
    return null;
  }